import { HTMLAttributes, ReactNode, useRef } from 'react'
import { cn } from '@dashboard/ui'
import { Handle, Position } from 'reactflow'

export interface ShadowHoverBlockProps extends HTMLAttributes<HTMLDivElement> {
  color: string
  selected?: boolean
  hasNext: boolean
  disabledOutput?: boolean
  children?: ReactNode
}

export const OctagonHoverBlock = ({
  disabledOutput,
  selected,
  color,
  className,
  hasNext,
  children,
}: ShadowHoverBlockProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const svgRef = useRef<SVGSVGElement>(null)
  return (
    <div
      ref={ref}
      onMouseOver={() => {
        if (svgRef.current) {
          ;(svgRef.current.firstChild as SVGPathElement).setAttribute('filter', `drop-shadow(1px 1px 2px ${color})`)
        }
        if (ref.current?.lastChild) {
          ;(ref.current.lastChild as HTMLDivElement).style.boxShadow = `1px 4px 22px 0px ${color}`
        }
      }}
      onMouseOut={() => {
        if (selected) {
          return
        }
        if (svgRef.current) {
          ;(svgRef.current.firstChild as SVGPathElement).removeAttribute('filter')
        }
        if (ref.current?.lastChild) {
          ;(ref.current.lastChild as HTMLDivElement).style.boxShadow = ''
        }
      }}
      className={cn(`relative flex size-[68px] cursor-pointer items-center justify-center`, className)}
    >
      <div
        style={{
          border: `2px solid #68C9E7`,
        }}
        className="absolute top-[-8px] z-[-1] size-[16px] overflow-visible rounded-full bg-fg-primary"
      />
      <svg
        width="69"
        height="68"
        viewBox="0 0 69 68"
        fill="none"
        style={{ color: color, position: 'absolute', zIndex: -1 }}
        ref={svgRef}
      >
        <path
          d="M23.6642 9.17062C23.9294 9.17062 24.1838 9.06526 24.3713 8.87772L30.7512 2.49778C32.7483 0.500742 35.9861 0.50074 37.9831 2.49777L44.3631 8.87772C44.5506 9.06526 44.805 9.17062 45.0702 9.17062H54.086C56.9102 9.17062 59.1997 11.4601 59.1997 14.2843V23.3001C59.1997 23.5653 59.3051 23.8197 59.4926 24.0072L65.8694 30.384C67.8664 32.3811 67.8664 35.6189 65.8694 37.616L59.4926 43.9928C59.3051 44.1803 59.1997 44.4347 59.1997 44.6999V53.7215C59.1997 56.5457 56.9102 58.8352 54.086 58.8352H45.0644C44.7991 58.8352 44.5448 58.9406 44.3573 59.1281L37.9831 65.5022C35.9861 67.4993 32.7483 67.4993 30.7512 65.5022L24.3771 59.1281C24.1896 58.9406 23.9352 58.8352 23.67 58.8352H14.6488C11.8246 58.8352 9.53509 56.5457 9.53509 53.7215V44.7003C9.53509 44.4351 9.42973 44.1807 9.2422 43.9932L2.86497 37.616C0.867929 35.6189 0.867928 32.3811 2.86496 30.384L9.2422 24.0068C9.42973 23.8193 9.53509 23.5649 9.53509 23.2997V14.2843C9.53509 11.4601 11.8246 9.17062 14.6488 9.17062H23.6642Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
          fill={'#fff'}
          filter={selected ? `drop-shadow(1px 1px 2px ${color})` : ''}
        />
      </svg>
      <Handle
        type={'target'}
        id={'input'}
        position={Position.Top}
        className="absolute left-1/2 top-[-8px] z-10 h-full w-[70px] rounded-none opacity-0"
        isConnectable={true}
      />
      {!disabledOutput && (
        <Handle
          type={'source'}
          id={'output'}
          position={Position.Bottom}
          isConnectable={true}
          style={{
            transform: 'translate(-50%, 5px)',
            borderRadius: '100%',
            border: `2px solid #68C9E7`,
            bottom: hasNext ? '' : '-105px',
            zIndex: hasNext ? -2 : 1,
          }}
          className="size-[16px] bg-fg-primary"
        />
      )}
      {children}
    </div>
  )
}
